import { useMutation, useQueryClient } from 'react-query';
import api from 'api';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
export const useOptinsMutation = ({
  clinicReferenceId
}) => {
  const personReferenceId = usePersonId();
  const client = useQueryClient();
  return useMutation(({
    confidentialityAgreementAccepted,
    marketingCommunicationConsentAccepted
  }) => api.ana.postOptins({
    personReferenceId,
    clinicReferenceId,
    ...(confidentialityAgreementAccepted && {
      confidentialityAgreementAccepted
    }),
    ...(marketingCommunicationConsentAccepted && {
      marketingCommunicationConsentAccepted
    })
  }), {
    onSuccess: () => {
      client.invalidateQueries(['anamnesis_listing', personReferenceId]);
    }
  });
};